import React, { createContext, useContext, useState, useEffect } from 'react';

const HospitalContext = createContext();

export const useHospital = () => {
  const context = useContext(HospitalContext);
  if (!context) {
    throw new Error('useHospital must be used within HospitalProvider');
  }
  return context;
};

const MOCK_HOSPITALS = [
  {
    id: 'hosp-001',
    name: 'Central Medical Hospital',
    logo: '🏥',
    address: '123 Healthcare Ave, Medical City',
    phone: '+1 234 567 8900',
  },
  {
    id: 'hosp-002',
    name: 'City General Hospital',
    logo: '🏨',
    address: '456 Health Street, Downtown',
    phone: '+1 234 567 8901',
  },
];

export const HospitalProvider = ({ children }) => {
  const [currentHospital, setCurrentHospital] = useState(MOCK_HOSPITALS[0]);
  const [hospitals, setHospitals] = useState(MOCK_HOSPITALS);

  useEffect(() => {
    const savedHospitalId = localStorage.getItem('hms-current-hospital');
    if (savedHospitalId) {
      const hospital = hospitals.find(h => h.id === savedHospitalId);
      if (hospital) {
        setCurrentHospital(hospital);
      }
    }
  }, [hospitals]);

  const switchHospital = (hospitalId) => {
    const hospital = hospitals.find(h => h.id === hospitalId);
    if (hospital) {
      setCurrentHospital(hospital);
      localStorage.setItem('hms-current-hospital', hospitalId);
    }
  };

  return (
    <HospitalContext.Provider value={{ currentHospital, hospitals, switchHospital }}>
      {children}
    </HospitalContext.Provider>
  );
};